import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../src/common/SafeIcon';

const { FiBook, FiZap, FiDatabase, FiClock, FiPieChart, FiShield, FiBookOpen, FiAward, FiFileText } = FiIcons;

export const Courses: React.FC = () => {
  const modules = [
    { title: "Introduction", desc: "Course objectives & overview", icon: FiBook, topics: ["Overview", "Goals"] },
    { title: "The Advisor Landscape", desc: "Fiduciary duty & client FOMO", icon: FiIcons.FiUsers, topics: ["Advisor posture", "Institutional context"] },
    { title: "Bitcoin Fundamentals", desc: "Scarcity & supply dynamics", icon: FiDatabase, topics: ["What Bitcoin is", "21M cap"] },
    { title: "Mining and Energy", desc: "PoW & security budget", icon: FiZap, topics: ["Proof of Work", "Energy mix"] },
    { title: "Historical Context", desc: "Adoption curves & volatility", icon: FiClock, topics: ["Adoption phases", "Behavioral finance"] },
    { title: "Portfolio Risk", desc: "Correlation & diversification", icon: FiPieChart, topics: ["Diversification", "Suitability"] },
    { title: "Regulation", desc: "Compliance boundaries", icon: FiShield, topics: ["Firm restrictions", "Education vs Advice"] },
  ];

  return (
    <section className="py-24 bg-white relative" id="curriculum">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="text-brand-600 font-semibold tracking-wider uppercase text-sm">Curriculum</span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-slate-900 mt-2 mb-4">A Structured Learning Path</h2>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-slate-200 hidden md:block"></div>
          <div className="space-y-12">
            {modules.map((mod, idx) => (
              <div key={idx} className="relative flex flex-col md:flex-row gap-8 items-start group">
                <div className="absolute left-8 -translate-x-1/2 w-4 h-4 rounded-full bg-white border-4 border-brand-500 z-10 hidden md:block mt-6"></div>
                <div className="flex-shrink-0 w-16 h-16 rounded-2xl bg-brand-50 border border-brand-100 flex items-center justify-center text-brand-600 shadow-sm z-20">
                   <SafeIcon icon={mod.icon as any} className="w-8 h-8" />
                </div>
                <div className="flex-grow bg-white border border-slate-100 rounded-2xl p-6 shadow-sm hover:shadow-lg transition-shadow duration-300 w-full">
                    <h3 className="text-xl font-bold text-slate-900">Module {idx}: {mod.title}</h3>
                    <p className="text-slate-500 text-sm mb-4">{mod.desc}</p>
                    <div className="flex flex-wrap gap-2">
                        {mod.topics.map((t, i) => (
                            <span key={i} className="px-3 py-1 rounded-full bg-slate-50 text-slate-600 text-sm border border-slate-200">{t}</span>
                        ))}
                    </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-5xl mx-auto mt-20 grid md:grid-cols-3 gap-6">
             <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-xl p-6 text-white shadow-xl">
                <SafeIcon icon={FiBookOpen} className="w-8 h-8 text-brand-300 mb-4" />
                <h4 className="font-bold text-lg mb-2">Bonus Module</h4>
                <p className="text-slate-300 text-sm">Ongoing Education: How to keep learning without hype.</p>
             </div>
             <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm">
                <SafeIcon icon={FiAward} className="w-8 h-8 text-brand-600 mb-4" />
                <h4 className="font-bold text-lg text-slate-900 mb-2">Quiz + Survey</h4>
                <p className="text-slate-600 text-sm">Short quizzes to reinforce key concepts.</p>
             </div>
             <div className="bg-white border border-slate-200 rounded-xl p-6 shadow-sm">
                <SafeIcon icon={FiFileText} className="w-8 h-8 text-brand-600 mb-4" />
                <h4 className="font-bold text-lg text-slate-900 mb-2">Glossary</h4>
                <p className="text-slate-600 text-sm">Terms and Definitions: A practical glossary.</p>
             </div>
        </div>
      </div>
    </section>
  );
};